import { useAppContext } from "@/appContext";
import { useEffect } from "react";
import Loading from "react-loading";

const Solution = () => {
  const { state, asyncGetAnswer } = useAppContext();

  useEffect(() => {
    if (!state.session[state.currentQuestion].samplesolution && state.session[state.currentQuestion].feedback !== "" ) asyncGetAnswer();
  }, [
    state.currentQuestion,
    state.session[state.currentQuestion]?.samplesolution,
  ]);

  if (!state.session[state.currentQuestion].samplesolution)
    return (
      <div className="h-[100vh] flex justify-center items-center">
        <Loading color="#000000" width={100} height={100} type="bubbles" />
      </div>
    );

  return (
    <div className="flex flex-col py-[30px] px-[24px] text-justify gap-3 h-[100vh] overflow-scroll">
      {state.session[state.currentQuestion].samplesolution
        .split("<br/>")
        .map((a, i) => (
          <p key={i}>{a.replaceAll("*", "")}</p>
        ))}
    </div>
  );
};

export default Solution;
